import { Component, Output, EventEmitter } from '@angular/core';
import * as debug from 'debug';
import * as _ from 'lodash';
import { UserProvider } from '../../providers/user/user';
import { ConfigProvider } from '../../providers/config/config';

@Component({
  selector: 'post-boost',
  templateUrl: 'post-boost.html',
})
export class PostBoostComponent {
  log = debug('app:CommentsAndRepliesComponent');

  @Output()
  close = new EventEmitter();
  @Output()
  submit = new EventEmitter();

  karmaMile: number = 0;
  boostCost: number = 100;
  remaining: number = -1;
  Math: any;

  constructor(public user: UserProvider, public config: ConfigProvider) {
    this.log('PostBoostComponent constructed');
    this.Math = Math;
  }

  ngOnInit(): void {
    this.karmaMile = _.get(this.user.info, 'stats.events.karmaMile') || 0;
    this.boostCost = Math.abs(this.config.get('karmaMiles').POST_BOOST) || 100;
    this.remaining = this.karmaMile - this.boostCost;
  }

  closeModal(): void {
    this.close.emit('close');
  }

  submitPost(boosted = true): void {
    let spendKarma = {
      category: 'POST_BOOST',
      price: 60,
    };
    this.submit.emit(boosted ? spendKarma : null);
  }

  preventDefault(e) {
    try {
      e.stopPropagation();
      e.preventDefault();
    } catch (e) {}
  }
}



// WEBPACK FOOTER //
// ./src/components/post-boost/post-boost.ts